import { SystemStyleObject } from '@chakra-ui/react';

export const getSkeletonSx = ({
  accessorKey,
}: {
  accessorKey: string;
}): SystemStyleObject => {
  switch (accessorKey) {
    case 'avatar':
      return {
        w: 10,
        h: 10,
        rounded: 'full',
      };
    case 'controls':
      return {
        w: 5,
        h: 5,
        rounded: 'full',
      };
    case 'accessory':
      return {
        w: 10,
        h: 10,
        rounded: 2,
      };
    default:
      return {
        h: 6,
      };
  }
};
